module.exports = __webpack_public_path__ + "static/media/Backbeach3.5df0daf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Backbeach3.png
// module id = 377
// module chunks = 0